import { EvaluateExpensableDocument } from 'generated/resources/graphql'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import { buildEvaluatePolicyData } from 'modules/expenses/lib/spending_policies/evaluatePolicy'

interface ExpenseData {
  expensableId?: number
  amount?: number
  currency?: string
  category?: string
  subcategory?: string | null
  effectiveOn?: string
  employeeId: number
  companyId: string
  canUseSpendingPolicies: boolean
}

export const useSpendingPolicies = (expenseData: ExpenseData) => {
  const {
    amount,
    currency,
    category,
    effectiveOn,
    canUseSpendingPolicies,
  } = expenseData

  const { data, loading, refetch } = useQuery(EvaluateExpensableDocument, {
    variables: {
      amount: amount || 0,
      currency: currency || '',
      category: category || '',
      effectiveOn: effectiveOn,
      subcategory: expenseData.subcategory,
      companyId: expenseData.companyId,
      employeeId: expenseData.employeeId,
      expensableId: expenseData.expensableId,
    },
    skip:
      !amount ||
      !currency ||
      !category ||
      !effectiveOn ||
      !canUseSpendingPolicies,
  })
  const policyEvaluation = data?.finance.expenseSpendingPolicyEvaluationsConnection.nodes[0]

  const policyData = useUnsafeMemo(
    () => buildEvaluatePolicyData(policyEvaluation),
    [policyEvaluation]
  )
  return { spendingPoliciesResult: policyData, loading, refetch }
}
